const StatesSelector = ({
	currentOption,
	onStateSelected,
	role
}) => {
	const handleChange = (event) => {
		const { value } = event.target;
		onStateSelected(value);
	};

	return (
		<select
			value={currentOption}
			className='form-control study-state-selector'
			onChange={handleChange}
		>
			<option value='none'>Filter by status</option>
			<option
				value={
					role === 'Under Q.A.M. Review' ? 'TWO' : 'ONE'
				}
			>
				Ready For Review
			</option>
			<option
				value={
					role === 'Under Q.A.M. Review' ? 'ONE' : 'TWO'
				}
			>
				{role}
			</option>
			<option value={'REVISION_REQUESTED'}>
				Revision Requested
			</option>
			<option value={'ARCHIVED'}>Archived</option>
			<option value={'STUDY_COMPLETED'}>Completed</option>
			<option value={'SUBMITTED_FOR_ANALYSIS'}>
				Submitted
			</option>
		</select>
	);
};

export default StatesSelector;
